import cn from 'classnames';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IKnmActFamiliarizationNotificationsForm } from 'KnmErknmPackage/MainModule/interfaces/IKnmActFamiliarizationNotificationsForm';
import { Row } from 'UIPackage/FormModule/components/Row';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { ErknmFieldMark } from 'KnmErknmPackage/MainModule/components/ErknmFieldMark';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';
import { makeMaxCharactersValidator } from 'CorePackage/MainModule/validators/maxCharacters';
import { MAX_CHARACTERS_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { CloseButton } from 'UIPackage/MainModule/components/CloseButton';
import { SelectInputFieldAutoOptions } from 'UIPackage/MainModule/components/SelectInputFieldAutoOptions';

import styles from './ResultDecisionsItemContentIntroductionsItem.module.scss';

interface IResultDecisionsItemContentIntroductionsItemProps {
  fieldValue: IKnmActFamiliarizationNotificationsForm;
  id: string;
  name: string;
  isDisabledField: boolean;
  remove: () => void;
}

export const ResultDecisionsItemContentIntroductionsItem = ({
  id,
  name,
  fieldValue,
  isDisabledField,
  remove,
}: IResultDecisionsItemContentIntroductionsItemProps) => {
  const { isNew } = fieldValue;

  return (
    <Row id={id} isListItem key={id}>
      <FieldBlock
        size="col-3"
        label={
          <>
            Способ уведомления
            <ErknmFieldMark fieldName={`${name}.knmNoticeType`} />
          </>
        }
      >
        <SelectInputFieldAutoOptions
          id={`${id}.knmNoticeType`}
          name={`${name}.knmNoticeType`}
          disabled={isDisabledField}
          size="medium"
          optionName={CommonCatalogsNamesEnum.KNM_NOTICE_METHODS}
        />
      </FieldBlock>
      <FieldBlock
        size="col-3"
        label={
          <>
            Дата уведомления
            <ErknmFieldMark fieldName={`${name}.noticeDate`} />
          </>
        }
      >
        <DatePickerField
          name={`${name}.noticeDate`}
          id={`${id}.noticeDate`}
          disabled={isDisabledField}
          maxDate={new Date()}
        />
      </FieldBlock>
      <FieldBlock
        size="col-3"
        label={
          <>
            Примечание
            <ErknmFieldMark fieldName={`${name}.note`} />
          </>
        }
      >
        <TextInputField
          id={`${id}.note`}
          name={`${name}.note`}
          disabled={isDisabledField}
          validate={composeValidators(makeMaxCharactersValidator(8000, MAX_CHARACTERS_ERROR))}
        />
      </FieldBlock>
      {!isDisabledField && (
        <CloseButton
          className={cn('shared-deleting-row-btn', styles.DeleteButton, { [styles.isShowBtnDel]: !isNew })}
          onClick={remove}
          disabled={!isNew}
        />
      )}
    </Row>
  );
};
